<h5>
	<strong>Theme Settings</strong>
</h5>
<div class="cui__utils__line" style="margin-top: 25px; margin-bottom: 30px"></div>
<div class="cui__sidebar__type">
	<div class="cui__sidebar__type__title">
		<span>Application Name</span>
	</div>
	<div class="cui__sidebar__type__items">
		<input nz-input [ngModel]="logo" (ngModelChange)="settingChange($event, 'logo')" />
	</div>
</div>
<div class="cui__sidebar__type">
	<div class="cui__sidebar__type__title">
		<span>Menu Layout</span>
	</div>
	<div class="cui__sidebar__type__items">
		<nz-radio-group [(ngModel)]="menuLayoutType" (ngModelChange)="settingChange($event, 'menuLayoutType')">
			<div nz-row>
				<div nz-col [nzSpan]="12">
					<div class="mb-2">
						<label nz-radio nzValue="left">Left Menu</label>
					</div>
					<div class="mb-2">
						<label nz-radio nzValue="top">Top Menu</label>
					</div>
				</div>
				<div nz-col [nzSpan]="12">
					<div class="mb-2">
						<label nz-radio nzValue="nomenu">No menu</label>
					</div>
				</div>
			</div>
		</nz-radio-group>
	</div>
</div>

<div class="cui__sidebar__type mb-4">
	<div class="cui__sidebar__type__title">
		<span>Internationalization</span>
	</div>
	<div class="cui__sidebar__type__items">
		<nz-select style="width: 100%;" [(ngModel)]="locale" (ngModelChange)="settingChange($event, 'locale')">
			<nz-option nzLabel="English (en-US)" nzValue="en-US"></nz-option>
			<nz-option nzLabel="Deutsch (de-DE)" nzValue="de-DE"></nz-option>
		</nz-select>
	</div>
</div>
<div class="cui__sidebar__type mb-2">
	<div class="cui__sidebar__type__title">
		<span>Left Menu Width</span>
	</div>
	<div class="cui__sidebar__type__items">
		<nz-slider [ngModel]="leftMenuWidth" (ngModelChange)="setWidth($event)" [nzMin]="256" [nzMax]="330">
		</nz-slider>
	</div>
</div>
<div class="cui__sidebar__item">
	<div class="cui__sidebar__label">Left Menu: Collapsed</div>
	<div class="cui__sidebar__container">
		<nz-switch [(ngModel)]="isMenuCollapsed" (ngModelChange)="settingChange($event, 'isMenuCollapsed')"
			[nzDisabled]="menuLayoutType !== 'left'"></nz-switch>
	</div>
</div>
<div class="cui__sidebar__item">
	<div class="cui__sidebar__label">Left Menu: Unfixed</div>
	<div class="cui__sidebar__container">
		<nz-switch [(ngModel)]="isMenuUnfixed" (ngModelChange)="settingChange($event, 'isMenuUnfixed')"
			[nzDisabled]="menuLayoutType !== 'left'"></nz-switch>
	</div>
</div>
<div class="cui__sidebar__item">
	<div class="cui__sidebar__label">Left Menu: Shadow</div>
	<div class="cui__sidebar__container">
		<nz-switch [(ngModel)]="isMenuShadow" (ngModelChange)="settingChange($event, 'isMenuShadow')"
			[nzDisabled]="menuLayoutType !== 'left'"></nz-switch>
	</div>
</div>
<div class="cui__sidebar__item">
	<div class="cui__sidebar__label">Menu: Color</div>
	<div class="cui__sidebar__container">
		<ng-container
			*ngTemplateOutlet="colorTpl; context: {$implicit: 'menuColor', colors: ['white', 'gray', 'dark'], active: menuColor}">
		</ng-container>
	</div>
</div>
<div class="cui__sidebar__item">
	<div class="cui__sidebar__label">Auth: Background</div>
	<div class="cui__sidebar__container">
		<ng-container
			*ngTemplateOutlet="colorTpl; context: {$implicit: 'authPagesColor', colors: ['white', 'gray', 'image'], active: authPagesColor}">
		</ng-container>
	</div>
</div>
<div class="cui__sidebar__item">
	<div class="cui__sidebar__label">Topbar: Fixed</div>
	<div class="cui__sidebar__container">
		<nz-switch [(ngModel)]="isTopbarFixed" (ngModelChange)="settingChange($event, 'isTopbarFixed')"></nz-switch>
	</div>
</div>
<div class="cui__sidebar__item">
	<div class="cui__sidebar__label">Topbar: Gray Background</div>
	<div class="cui__sidebar__container">
		<nz-switch [(ngModel)]="isGrayTopbar" (ngModelChange)="settingChange($event, 'isGrayTopbar')"></nz-switch>
	</div>
</div>
<div class="cui__sidebar__item">
	<div class="cui__sidebar__label">App: Content Max-Width</div>
	<div class="cui__sidebar__container">
		<nz-switch [(ngModel)]="isContentMaxWidth" (ngModelChange)="settingChange($event, 'isContentMaxWidth')">
		</nz-switch>
	</div>
</div>
<div class="cui__sidebar__item">
	<div class="cui__sidebar__label">App: Max-Width</div>
	<div class="cui__sidebar__container">
		<nz-switch [(ngModel)]="isAppMaxWidth" (ngModelChange)="settingChange($event, 'isAppMaxWidth')"></nz-switch>
	</div>
</div>
<div class="cui__sidebar__item">
	<div class="cui__sidebar__label">App: Gray Background</div>
	<div class="cui__sidebar__container">
		<nz-switch [(ngModel)]="isGrayBackground" (ngModelChange)="settingChange($event, 'isGrayBackground')">
		</nz-switch>
	</div>
</div>
<div class="cui__sidebar__item">
	<div class="cui__sidebar__label">Cards: Squared Borders</div>
	<div class="cui__sidebar__container">
		<nz-switch [(ngModel)]="isSquaredBorders" (ngModelChange)="settingChange($event, 'isSquaredBorders')">
		</nz-switch>
	</div>
</div>
<div class="cui__sidebar__item">
	<div class="cui__sidebar__label">Cards: Shadow</div>
	<div class="cui__sidebar__container">
		<nz-switch [(ngModel)]="isCardShadow" (ngModelChange)="settingChange($event, 'isCardShadow')"></nz-switch>
	</div>
</div>
<div class="cui__sidebar__item">
	<div class="cui__sidebar__label">Cards: Borderless</div>
	<div class="cui__sidebar__container">
		<nz-switch [(ngModel)]="isBorderless" (ngModelChange)="settingChange($event, 'isBorderless')"></nz-switch>
	</div>
</div>

<ng-template #colorTpl let-setting let-colors="colors" let-active="active">
  <ng-container *ngFor="let item of colors">
    <a href="javascript: void(0);" (click)="settingChange(item, setting)" class="cui__sidebar__select__item" [ngClass]="{
        cui__sidebar__select__item__active: active === item, cui__sidebar__select__item__black: item === 'dark',
        cui__sidebar__select__item__white: item === 'white', cui__sidebar__select__item__gray: item === 'gray',
        cui__sidebar__select__item__blue: item === 'blue', cui__sidebar__select__item__img: item === 'image'}"></a>
  </ng-container>
</ng-template>
